var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 79,
    viewBox: "0 0 71 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71 36.0127V18.6643C71 15.4227 68.5284 11.7492 65.4621 10.522L43.2706 1.51078C38.2902 -0.503717 32.6726 -0.503717 27.6922 1.51078L5.49809 10.522C2.46897 11.7465 0 15.4227 0 18.6643V36.0127C0 55.3387 14.1448 73.4376 33.4664 78.7333C34.7805 79.0888 36.2168 79.0888 37.5309 78.7333C56.8552 73.4376 70.9973 55.3387 70.9973 36.0127H71ZM38.4893 42.9278V53.3216C38.4893 54.9411 37.1354 56.2867 35.5 56.2867C33.8646 56.2867 32.5107 54.9437 32.5107 53.3216V42.9278C28.486 41.6638 25.5392 37.9482 25.5392 33.5611C25.5392 28.1074 30.0019 23.6808 35.5 23.6808C40.9981 23.6808 45.4608 28.1074 45.4608 33.5611C45.4608 37.9877 42.5113 41.6638 38.4893 42.9278Z",
    fill: "#FF7324"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPrivacy);
export default __webpack_public_path__ + "static/media/IconPrivacy.c3bc5b0f106768a9c8dd893214612fcb.svg";
export { ForwardRef as ReactComponent };